module.exports = __webpack_public_path__ + "static/follow-us-mobile-e14749f887b8beb6c9ae6024e8a617dd.svg";